/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import axios from '@/plugins/axios'
import { downLoad } from '@/utils'
import {
  getlist,
  getchildList,
  postadd,
  putupdate,
  getget,
  deleteremove,
  putissue,
  putfinish,
  putend,
  putsubmit,
  getfeedbackList,
  getsignList,
  getlistDownOrg,
  getlistAUser,
  getoneselfList,
  putoneselfSign,
  deleteremoveScope,
  putagainSign,
  postimportSign,
  getexportSign,
  postaddSignUser,
  getremindOrg,
  getremindUser,
  getgetSignInfo
} from './model'
import {ValidateType} from './model/utils'
const isPod = process.env.NODE_ENV === 'production'

let validatelist = new ValidateType(getlist.Req, '/declarationSign/list', 'GET')
export function list (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelist.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/list',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatechildList = new ValidateType(getchildList.Req, '/declarationSign/childList', 'GET')
export function childList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatechildList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/childList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateadd = new ValidateType(postadd.Req, '/declarationSign/add', 'POST')
export function add (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateadd.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/add',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateupdate = new ValidateType(putupdate.Req, '/declarationSign/update', 'PUT')
export function update (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateupdate.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/update',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateget = new ValidateType(getget.Req, '/declarationSign/get', 'GET')
export function get (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateget.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/get',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateremove = new ValidateType(deleteremove.Req, '/declarationSign/remove', 'DELETE')
export function remove (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateremove.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/remove',
    method: 'DELETE',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateissue = new ValidateType(putissue.Req, '/declarationSign/issue', 'PUT')
export function issue (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateissue.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/issue',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatefinish = new ValidateType(putfinish.Req, '/declarationSign/finish', 'PUT')
export function finish (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatefinish.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/finish',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateend = new ValidateType(putend.Req, '/declarationSign/end', 'PUT')
export function end (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateend.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/end',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesubmit = new ValidateType(putsubmit.Req, '/declarationSign/submit', 'PUT')
export function submit (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesubmit.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/submit',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatefeedbackList = new ValidateType(getfeedbackList.Req, '/declarationSign/feedbackList', 'GET')
export function feedbackList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatefeedbackList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/feedbackList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesignList = new ValidateType(getsignList.Req, '/declarationSign/signList', 'GET')
export function signList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesignList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/signList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistDownOrg = new ValidateType(getlistDownOrg.Req, '/declarationSign/listDownOrg', 'GET')
export function listDownOrg (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistDownOrg.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/listDownOrg',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatelistAUser = new ValidateType(getlistAUser.Req, '/declarationSign/listAUser', 'GET')
export function listAUser (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatelistAUser.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/listAUser',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateoneselfList = new ValidateType(getoneselfList.Req, '/declarationSign/oneselfList', 'GET')
export function oneselfList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateoneselfList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/oneselfList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateoneselfSign = new ValidateType(putoneselfSign.Req, '/declarationSign/oneselfSign', 'PUT')
export function oneselfSign (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateoneselfSign.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/oneselfSign',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateremoveScope = new ValidateType(deleteremoveScope.Req, '/declarationSign/removeScope', 'DELETE')
export function removeScope (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateremoveScope.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/removeScope',
    method: 'DELETE',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateagainSign = new ValidateType(putagainSign.Req, '/declarationSign/againSign', 'PUT')
export function againSign (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateagainSign.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/againSign',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateimportSign = new ValidateType(postimportSign.Req, '/declarationSign/importSign', 'POST')
export function importSign (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateimportSign.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/importSign',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateexportSign = new ValidateType(getexportSign.Req, '/declarationSign/exportSign', 'GET')
export function exportSign (req, config = {}, filterKey = []) {
  downLoad('/declarationSign/exportSign', req)
}

let validateaddSignUser = new ValidateType(postaddSignUser.Req, '/declarationSign/addSignUser', 'POST')
export function addSignUser (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateaddSignUser.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/addSignUser',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateremindOrg = new ValidateType(getremindOrg.Req, '/declarationSign/remindOrg', 'GET')
export function remindOrg (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateremindOrg.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/remindOrg',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateremindUser = new ValidateType(getremindUser.Req, '/declarationSign/remindUser', 'GET')
export function remindUser (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateremindUser.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/remindUser',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetSignInfo = new ValidateType(getgetSignInfo.Req, '/declarationSign/getSignInfo', 'GET')
export function getSignInfo (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetSignInfo.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/declarationSign/getSignInfo',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}